<template>
  <router-link
    :class="properties.class"
    :id="properties.id"
    :to="{ name: getRoutes }"
    :type="properties.type"
    @mouseup="callBackFunction"
  >
    {{ properties.label }}
  </router-link>
</template>

<script>
export default {
  name: "navButton",
  routeName: "",
  props: {
    properties: Object,
  },
  data() {
    return {
      route: "",
      callBackFunction: function () {},
    };
  },
  computed: {
    getRoutes() {
      // Get language
      let langArray = "";
      let langMain = "";

      if (this.$store.getters.getLang.includes("-")) {
        langArray = this.$store.getters.getLang.split("-");
        langMain = langArray[0].toLowerCase();
      } else {
        langMain = this.$store.getters.getLang.toLowerCase();
      }

      if (
        this.properties.routeName !== undefined &&
        this.properties.routeName !== ""
      ) {
        return `${langMain}-${this.properties.routeName}`;
      } else {
        return this.$route.name;
      }
    },
  },
  methods: {},
  created() {
    if (typeof this.properties.function === "function") {
      this.callBackFunction = this.properties.function;
    }
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>
